import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/brand";

export const PLANS = [
  { id: "1m", slug: "monthly", name: "Monthly", rzpName: "Little Lantern Monthly", months: 1, price: 444, durationLabel: "1 month", recurring: true },
  { id: "3m", slug: "3-months", name: "Three months", rzpName: "Little Lantern Quarterly", months: 3, price: 1111, durationLabel: "3 months", recurring: true },
  { id: "6m", slug: "6-months", name: "Six months", rzpName: "Little Lantern Bi-Annually", months: 6, price: 2222, durationLabel: "6 months", highlight: "a lovely middle path", recurring: true },
  { id: "12m", slug: "12-months", name: "A whole year", rzpName: "Little Lantern Yearly", months: 12, price: 4444, durationLabel: "12 months", highlight: "a year of little lights", recurring: true },
  { id: "1x", slug: "one-time", name: "One-time envelope", rzpName: "Little Lantern One-time", months: 1, price: 555, durationLabel: "one envelope", recurring: false },
];
export const SUBSCRIPTION_PLANS = PLANS.filter((p) => p.recurring);
export const ONE_TIME_PLAN = PLANS.find((p) => !p.recurring);

const LEGACY = { monthly: "Monthly ₹999 (old)", onetime: "One-time ₹1111 (old)" };

export const inr = (n) => `₹${n.toLocaleString("en-IN")}`;
export const billingLine = (p) => {
  if (!p.recurring) return `${inr(p.price)} once, no renewal`;
  return p.months === 1 ? `${inr(p.price)} every month` : `${inr(p.price)} every ${p.months} months`;
};
export const envelopesLine = (p) => (p.months === 1 ? "1 envelope" : `${p.months} envelopes, one each month`);
export const planBySlug = (slug) => PLANS.find((p) => p.slug === slug);
export const planLabel = (id) => {
  const p = PLANS.find((x) => x.id === id);
  if (!p) return LEGACY[id] || id;
  return p.recurring ? `${p.durationLabel} · ${inr(p.price)}` : `One-time · ${inr(p.price)}`;
};

export const usePlanAvailability = () => {
  const [available, setAvailable] = useState(null);
  useEffect(() => {
    axios.get(`${API}/config`)
      .then((r) => setAvailable(Object.fromEntries(r.data.plans.map((p) => [p.id, p.available]))))
      .catch(() => setAvailable({}));
  }, []);
  return available;
};
